// src/api/favoritesApi.js
import AuthService from "./axiosInstance";
import endpoints from "./endpoints";

const favoritesApi = {
  async getFavorites() {
    const res = await AuthService.get(endpoints.FAVORITES);
    const data = res.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.results)) return data.results;
    return [];
  },

  async addFavorite(companyId) {
    const res = await AuthService.post(endpoints.FAVORITES, {
      company_id: companyId,
    });
    return res.data;
  },

  async removeFavorite(favoriteId) {
    await AuthService.delete(endpoints.FAVORITE_DETAIL(favoriteId));
  },
};

export default favoritesApi;
